import React, { Component } from 'react'
import { TextField, Button, Snackbar, Slide, FormControl, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, CircularProgress } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import AutocompleteAsyncrono from '../Autocomplete';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import './Form.css';
import { Form } from './DynamicFormTs';
import Http from '../../Http';
import { theme } from '../../Theme';
import ColorPicker from './ColorPicker/ColorPicker';
import { AuthContext } from '../../context/authContext';

export class DynamicForm extends Component {

  static defaultProps = {
    form: new Form(),
    buttonId: 0,
  }
  
  valueChange = (field, event, eform, atVal = false) => {
    const { form } = this.props;
    let newFields = form.Fields.map((mapField) => {
      if (mapField.Name === field.Name) {
        mapField.Changed = true;
        if (mapField.Type === 'autocomplete') {
          if (!atVal) {
            mapField.ValueAt = event.target.value;
          } else {
            mapField.Value = event;
          }
        }
        else if (mapField.Type === 'checkbox') {
          mapField.Value = event.target.checked;
        }
        else if (mapField.Type === 'file') {
          mapField.Value =  event.target.files;
        }
        else if (mapField.Type === 'color') {
          mapField.Value =  event;
        }
        else {
          mapField.Value = event.target.value 
        }
        field = { ...mapField }
        return field;
      } else {
        return { ...mapField }
      }
    });
    let newForm = {...form};
    newForm.Fields = newFields;

    /* VALIDAR FORMULARIO */
    let fieldsValid = {};
    newForm.Invalid = newForm.Fields.some((field, fi) => {
      let isInvalid = !Form.ValidateField(newForm, field);
      newForm.Fields[fi].Invalid = isInvalid;
      fieldsValid[field.Name] = isInvalid;
      return isInvalid;
    })
    this.props.formChange(newForm, field, 'value')
  }

  optionsChange = (field, options) => {
    const { form } = this.props;
    let newForm = {
      ...form,
      Fields: form.Fields.map(f => {
        if (f.Name == field.Name) {
          f.Options = options;
          field = f; 
        }
        return {...f};
      })
    };
    
    this.props.formChange(newForm, field, 'options')
  }

  resetChange = (field, value) => {
    const { form } = this.props;
    let newForm = {
      ...form,
      Fields: form.Fields.map(f => {
        if (f.Name == field.Name) {
          f.Reset = value;
          field = f; 
        }
        return {...f};
      })
    };
    
    this.props.formChange(newForm, field, 'options')
  }

  fieldBlur = () => {}
  
  submit = (e) => {
    e.preventDefault();
    let vals = {};
    this.props.form.Fields.forEach((field) => {
      if (field.Type !== 'section' && field.Type !== 'space' && field.Type !== 'button')
        vals[field.Name] = field.Value;
    });

    this.props.onSubmit(this.state.buttonId, vals);
  }

  render() {
    const { form, children, loading = false, disabled = false } = this.props;
    return (
      <div>
        {form.Title &&
          <h1>{form.Title}</h1>
        }
        <form onSubmit={this.submit}>
          <div className='row row-form'>
            {form.Fields.map((formField, i) => {
              formField.Disabled = formField.Disabled || disabled; 
              if (formField.Type === 'section') return (
                <div key={i} className={`col-12 col-sm-${formField.Col} section`}>
                  {formField.Value === 1 &&
                    <h3 style={{ backgroundColor: theme.palette.primary.main }}>{formField.Label}</h3>
                  }
                  {formField.Value === 2 &&
                    <h4 style={{ 
                      margin:'0px', 
                      backgroundColor: theme.palette.secondary.main, 
                      color: '#fff', 
                      width: 'fit-content',
                      padding: '2px 14px'
                    }}>
                      {formField.Label}
                    </h4>
                  }
                </div>
              )
              if (formField.Type === 'hidden') return (<div key={i}></div>)
              return (
                <div key={i} className={`col-12 col-sm-${formField.Col}`}>
                  {(formField.Type === 'text' || formField.Type === 'number' || formField.Type === 'password') && (
                    <TextField
                      disabled={formField.Disabled}
                      error={formField.ErrorMessages.length > 0}
                      autoFocus={i === 0}
                      variant="outlined"
                      className="form-field"
                      type={formField.Type}
                      inputProps={formField.Type === 'number' ? { step: 'any' } : {}}
                      label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                      value={formField.Value || ''}
                      onChange={(e) => { this.valueChange(formField, e, form) }}
                      onBlur={(e) => { this.fieldBlur(formField, e) }}
                    />
                  )}

                  {(formField.Type === 'time') && (
                    <TextField
                      error={formField.ErrorMessages.length > 0}
                      disabled={formField.Disabled}
                      InputLabelProps={{
                        shrink: true
                      }}
                      autoFocus={i === 0}
                      variant="outlined"
                      className="form-field"
                      type={formField.Type}
                      label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                      value={formField.Value}
                      onChange={(e) => { this.valueChange(formField, e, form) }}
                      onBlur={(e) => { this.fieldBlur(formField, e) }} />
                  )}

                  {(formField.Type === 'textarea') && (
                    <TextField
                      minRows={2}
                      disabled={formField.Disabled}
                      error={formField.ErrorMessages.length > 0}
                      autoFocus={i === 0}
                      multiline
                      fullWidth
                      variant="outlined"
                      className="form-field"
                      type={formField.Type}
                      label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                      value={formField.Value || ''}
                      onChange={(e) => { this.valueChange(formField, e, form) }}
                      onBlur={(e) => { this.fieldBlur(formField, e) }} />
                  )}

                  {(formField.Type === 'select') && (
                    <FormControl disabled={formField.Disabled} error={formField.ErrorMessages.length > 0} variant="outlined" className='form-field'>
                      <InputLabel>{`${formField.Required ? '*' : ''} ${formField.Label}`}</InputLabel>
                      <Select
                        autoFocus={i === 0}
                        value={(formField.Value && formField.Options.length > 0) ? formField.Value : ''}
                        onChange={(e) => { this.valueChange(formField, e) }}
                        onBlur={(e) => { this.fieldBlur(formField, e) }}
                      >
                        {formField.Options.map((option, i) => {
                          return (<MenuItem value={option.Value} key={i}>{option.Label}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                  )}

                  {['autocomplete-async','autocomplete-async-cp'].includes(formField.Type) && (
                    <AutocompleteAsyncrono
                      cp={formField.Type === 'autocomplete-async-cp'}
                      disabled={formField.Disabled}
                      label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                      value={formField.Value}
                      onChange={(e) => { this.valueChange(formField, e) }}
                      onOptionsChange={(e) => { this.optionsChange(formField, e) }}
                      onBlur={(e) => { this.fieldBlur(formField, e) }}
                      apiUrl={formField.ApiUrl}
                      options={formField.Options}
                      reset={formField.Reset}
                      onResetChange={(e) => { this.resetChange(formField, e) }}
                    />
                  )}

                  {(formField.Type === 'radio') && (
                    <FormControl className='form-field'>
                      <FormLabel>{`${formField.Required ? '*' : ''} ${formField.Label}`}</FormLabel>
                      <RadioGroup 
                        autoFocus={i === 0} 
                        aria-label={formField.Label} 
                        name={formField.Name} 
                        value={formField.Value} 
                        onChange={(e) => { this.valueChange(formField, e, form) }} 
                        onBlur={(e) => { this.fieldBlur(formField, e) }}>
                        {formField.Options.map((option, i) =>
                          <FormControlLabel disabled={formField.Disabled}  key={i} value={option.Value.toString()} control={<Radio />} label={option.Label} />
                        )}
                      </RadioGroup>
                    </FormControl>
                  )}

                  {(formField.Type === 'checkbox') && (
                    <FormControl className='form-field'>
                      <FormControlLabel
                        control={
                          <Checkbox autoFocus={i === 0}
                            onChange={(e) => { this.valueChange(formField, e, form) }}
                            disabled={formField.Disabled}
                            checked={formField.Value === 1 || formField.Value === true}
                          // value={true} 
                          />}
                        label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                      />
                    </FormControl>
                  )}

                  {(formField.Type === 'date') && (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <FormControl className='form-field'>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          disabled={formField.Disabled}
                          error={formField.ErrorMessages.length > 0}
                          autoFocus={i === 0}
                          autoOk
                          label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                          inputVariant="outlined"
                          value={formField.Value}
                          format="dd/MM/yyyy"
                          onChange={(e) => { this.valueChange(formField, { target: { value: e } }, form) }} />
                      </FormControl>
                    </MuiPickersUtilsProvider>
                  )}
                  {(formField.Type === 'date-hour') && (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <FormControl className='form-field'>
                        <KeyboardDateTimePicker
                          disableToolbar
                          disabled={formField.Disabled}
                          error={formField.ErrorMessages.length > 0}
                          autoFocus={i === 0}
                          inputVariant="outlined"
                          variant="inline"
                          ampm={false}
                          value={formField.Value}
                          label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                          format="dd/MM/yyyy HH:mm"
                          disablePast
                          onChange={(e) => { this.valueChange(formField, { target: { value: e } }, form) }} />
                      </FormControl>
                    </MuiPickersUtilsProvider>
                  )}
                  {(formField.Type === 'button') && (
                    <Button fullWidth type="submit" variant="contained" onClick={() => this.setState({ buttonId: formField.Value })} disabled={formField.Disabled} >
                      {`${formField.Required ? '*' : ''} ${formField.Label}`}
                    </Button>
                  )}
                  {(formField.Type === 'autocomplete') && (
                    <Autocomplete
                      disabled={formField.Disabled}
                      className='form-field'
                      options={formField.Options}
                      value={(formField.Options.find((opt) => (opt.Value === formField.Value + '')) || formField.Value + '' || '')}
                      getOptionLabel={option => option.Label || option || ''}
                      onChange={(e, val) => { this.valueChange(formField, val ? val.Value : '', form, true) }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label={`${formField.Required ? '*' : ''} ${formField.Label}`}
                          variant="outlined"
                          fullWidth
                          error={formField.ErrorMessages.length > 0}
                          onChange={(e) => { this.valueChange(formField, e, form) }}
                          onBlur={(e) => { this.fieldBlur(formField, e) }} />
                      )}
                    />
                  )}
                  {(formField.Type === 'select_multiple') && (
                    <FormControl disabled={formField.Disabled} error={formField.ErrorMessages.length > 0} variant="outlined" className='form-field'>
                      <InputLabel>{`${formField.Required ? '*' : ''} ${formField.Label}`}</InputLabel>
                      <Select
                        multiple
                        autoFocus={i === 0}
                        value={formField.Value}
                        onChange={(e) => { this.valueChange(formField, e) }}
                        onBlur={(e) => { this.fieldBlur(formField, e) }}
                      >
                        {formField.Options.map((option, i) => {
                          return (<MenuItem value={option.Value} key={i}>{option.Label}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                  )}
                  {(formField.Type === 'file') && (
                    <div>
                      <input
                        accept={formField.Accept ? formField.Accept : ''}
                        type='file'
                        onChange={(e) => { this.valueChange(formField, e) }}
                      />
                    </div>
                  )}
                  {(formField.Type === 'space') && (
                    <span key={i}> </span>
                  )}
                  {(
                    formField.ErrorMessages &&
                    formField.ErrorMessages.map((message, index) => (<span className='error-message' key={`error-${index}`} >{message}</span>))
                  )}
                  {(
                    formField.WarningMessages &&
                    formField.WarningMessages.map((message, index) => (<span className='warning-message' key={`warning-${index}`} >{message}</span>))
                  )}
                  {/*  return (<div key={i} className={`col-12 col-sm-${formField.Col}`}>'{formField.Type}' no creado en formulario</div>) */}
                  {(formField.Type === 'color') && (
                    // <div>
                    <ColorPicker
                      value={formField.Value}
                      onChange={(e) => { this.valueChange(formField, e) }}
                      onBlur={(e) => { this.fieldBlur(formField, e) }}
                    />
                    // </div>
                  )}
                </div>

              )

            })}

          </div>
          {children}
          <div className="options">
            {form.Actions.map((label, i) => {
              return (
                <Button
                  style={{ marginLeft: 10 }}
                  key={i} type="submit"
                  variant="contained"
                  color={i < 1 ? 'primary' : 'default'}
                  disabled={form.Invalid || loading || disabled}
                  onClick={() => this.setState({ buttonId: i + 1 })}
                >
                  {i === 0 &&
                    <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loading}><CircularProgress color="secondary" size={20} /></div>
                  }
                  {label}
                </Button>
              )
            })}
          </div>
        </form>
      </div>
    )
  }
}

class FormComponent extends Component {

  static defaultProps = {
    onSave: () => { },
    back: true,
    reset: true
  }

  config = {}

  state = {
    FormData: new Form(),
    sbOpen: false,
    sbMsg: ''
  }

  FormConfig = async (config, data, formFill = null) => {
    this.FillForm(data, formFill);
    this.config = config;
    /* const Disabled = this.props.acciones
      && this.props.acciones.length > 0
      && (this.props.acciones.includes('show')
        || this.props.acciones.includes('show_sucursal')
        || this.props.acciones.includes('show_self'))
      && !this.props.acciones.some(accion => (accion === 'create' || accion === 'edit' || accion === 'edit_self')); */
    const Disabled = false;
    for (const field of data.Fields) {
      field.Disabled = field.Disabled || Disabled;
      field.Required = field.Validators.some(val => val('').name === 'required')
    }

    this.setState({ FormData: data, formDisabled: Disabled })
    // console.log(data)
  }

  FillForm = async (data, formFill) => {
    if (formFill) {
      Object.assign(data, await formFill(data))
      this.setState({ FormData: data })
      // console.log(this.state.FormData)
      // console.log(this.state.FormData)
    }
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`${this.config.defaultUrl}/${id}`);
    if (!Res.error) {
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, callOnChange) });
    }
    return Res.data;
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.match.params.id;
    // console.log('SUBMIT');
    this.setState({ loading: true });
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    // console.log('asd', Res);

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      if (this.props.reset)
        this.setState({ FormData: Form.Reset(this.state.FormData) });

      if (this.props.back)
        this.props.history.push(`${this.config.backUrl}`)
      this.props.onSave();
    }
    else
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });

  }
  formChange = (form, field) => { this.setState({ FormData: Form.Change(form, field) }) }

  FormRender = ({ extraComponent }) => {
    const { FormData, sbMsg, sbOpen, loading, disabled } = this.state;
    // const { params } = this.props.match;
    return (
      <div>
        <div className="form-box">
          <DynamicForm disabled={disabled} form={FormData} formChange={this.formChange} onSubmit={this.onSubmit} loading={loading}>
            {extraComponent}
          </DynamicForm>
        </div>

        <Snackbar
          open={sbOpen}
          onClose={() => { this.setState({ sbOpen: false }) }}
          TransitionComponent={Slide}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    )
  }
}

FormComponent.contextType = AuthContext

export { FormComponent };
